import RangeInput from '@/components/Inputs/RangeInput';

export const RangeFilter = (props: RangeFilterProps) => {
  return (
    <RangeInput
      values={props.values}
      onChange={props.onChange}
      placeholder={{ min: 'min count', max: 'max count' }}
    />
  );
};
